import { render, staticRenderFns } from "./ChefComplaint.vue?vue&type=template&id=8dbc7b5c&"
import script from "./ChefComplaint.vue?vue&type=script&lang=js&"
export * from "./ChefComplaint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports